import { API_BASE } from "../../config/env";
import axios from "axios";
export const FETCH_REGISTER_FULFILLED = "FETCH_REGISTER_FULFILLED";
export const FETCH_REGISTER_REJECTED = "FETCH_REGISTER_REJECTED";
export const FETCH_REGISTER_PENDING = "FETCH_REGISTER_PENDING";
export const RESET_REGISTER = "RESET_REGISTER";


export function register(email, password, agreementTypes) {
    const phoneNumber = localStorage.getItem("phoneNumber")
    const data = {
        phoneNumber: phoneNumber,
        email: email,
        password, password,
        agreementTypes: agreementTypes
    }
    const data_json = JSON.stringify(data)
    return (dispatch) => {
        dispatch({
            type: "FETCH_REGISTER",
            payload: axios({
                method: "post",
                url: `${API_BASE}/api/v2/user`,
                data: data_json,
                headers: {
                    "Accept-Language": "tr-tr",
                    "Client-Id": localStorage.getItem("One-Id"),
                    "One-Id": localStorage.getItem("Client-Id"),
                    "Content-Type": "application/json",
                    "ngrok-skip-browser-warning": "69920"
                },
            }).then((result) => result.data),
        });
    };
}

export function resetRegister() {
    return (dispatch) => {
        dispatch({
            type: "RESET_REGISTER",
        });
    };
}



